export const webClientId = '1079308835837-8cb7rqknf3eg4u1m7hibc3umgtbmbt0l.apps.googleusercontent.com'